$(function () {

    $(document).on('click', '#request_validation_form', function (e) { 
        e.preventDefault();
        var personal_number = $('#personal_number').val();
        console.log(personal_number);
        if (personal_number.length < 3) {
            bootbox.alert('Osobní číslo musí mít minimálně 3 znaky');
            return false;
        }

        var url = $(this).data('validation_send_url');

        $.when($.ajax({
            url: url,
            async: false,
            cache: false,
            method: 'post',
            data: {"personal_number":personal_number},
            success: function (data) {
                if (data.status === 'success') {
                    console.log(data);
                    bootbox.alert(data.data.msg);
                    $('#div_validation_code').css('display', 'block');
                    $('#request_validation_form').attr('id', 'request_validation_form_run')
                } else {
                    bootbox.alert(data.msg);
                }
            },
            error: function (data) {
                bootbox.alert('Došlo k chybě při ověření Vašeho osobního čísla.');
            }, dataType: 'json'
        })).done(function (result) {
            console.log(result);
            return result;
        });

        return true;
    });

    $(document).on('click', '#request_validation_form_run', function (e) { 
        e.preventDefault();
        var personal_number = $('#personal_number').val();
        var validation_code = $('#validation_code').val();
        if (validation_code.length != 6) {
            bootbox.alert('Validační kód musí mít 6 znaků');
            return false;
        }

        var url = $(this).data('validation_confirm');
        var redir_url = $(this).data('fill_url');

        $.when($.ajax({
            url: url,
            async: false,
            cache: false,
            method: 'post',
            data: {"personal_number":personal_number, "validation_code":validation_code},
            success: function (data) {
                if (data.status === 'success') {
                    console.log(data);
                    redir_url +=  '&validation_code='+data.data.validation_code+'&personal_number='+data.data.personal_number;
                    console.log(redir_url);
                    document.location = redir_url;
                } else {
                    bootbox.alert(data.msg);
                }
            },
            error: function (data) {
                bootbox.alert('Došlo k chybě při ověření Vašeho osobního čísla.');
            }, dataType: 'json'
        })).done(function (result) {
            console.log(result);
            return result;
        });

        return true;
    });

});